export default class LoadingService {
  constructor($rootScope) {
    'ngInject';

    Object.assign(this, { $rootScope });
  }

  stop() {
    this.$rootScope.loadingView = false;
  }

  start() {
    this.$rootScope.loadingView = true;
  }
}



// WEBPACK FOOTER //
// ./services/loading.service.js